import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import { AppConfig } from 'src/app/app.config';
import {
  MDMCommonConstants,
  PayerWrapperConstants,
} from 'src/app/mdm/constants/mdm-common-constants';
import { EnvironmentConfig } from 'src/app/shared/models/environment';

@Component({
  selector: 'app-pbm-cell-renderer',
  templateUrl: './pbm-cell-renderer.component.html',
  styleUrls: ['./pbm-cell-renderer.component.less'],
})
export class PbmCellRendererComponent implements OnInit {
  params: any;
  data: any;
  id: any;
  percent: any;
  MDMCommonConstants = MDMCommonConstants;
  sources: any;
  name: any;
  environment: EnvironmentConfig;
  PayerWrapperConstants = PayerWrapperConstants;
  constructor(private config: AppConfig, private router: Router) {
    this.environment = this.config.getConfigObject();
  }

  ngOnInit(): void { }
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.id = this.params.MSTR_MDM_ID;
    this.name = this.params.MSTR_PBM_NAME
    this.sources = this.params.SOURCES;
    this.data.suspected_sources = this.data.suspected_sources;
    this.percent = this.params.PERCENT;
  }

  refresh(params) {
    return true;
  }
  navigate(id) {
    this.router.navigate(['/mdm/all-records/payer/profile/', id], {
      state: { entity: PayerWrapperConstants.PBM, return_page: 'suspected' },
    });
  }
}
